import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/finance/organization-withdraw',
    name: 'organization-withdraw',
    component: () => import('../views/OrganizationWithdraw.vue')
  },
  {
    path: '/finance/user-withdraw',
    name: 'usern-withdraw',
    component: () => import('../views/UserWithdraw.vue')
  },
  {
    path: '/classes',
    name: 'classes',
    component: () => import('@/views/Classes.vue')
  },
  {
    path: '/host-income',
    name: 'host-income',
    component: () => import('@/views/HostIncome.vue')
  },
  {
    path: '/organization-management/programs',
    name: 'programs',
    component: () => import('@/views/Programs.vue')
  },
  {
    path: '/lesson/lesson-templates',
    name: 'lesson-templates',
    component: () => import('@/views/LessonTemplates.vue')
  },
  {
    path: '/manage/programs/upsert',
    name: 'upsert-program',
    component: () => import('@/views/ProgramUpsert.vue')
  },
  {
    path: '/manage/programs/purchase-packages-upsert',
    name: 'program-purchase-packages-upsert',
    component: () => import('@/views/ProgramPurchasePackagesUpsert.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
